import { getSelectedWorkspaceName, getSelectedScenarioName, } from "@focus/services/lib/scenarios/selectors";
import * as React from "react";
import { connect } from "react-redux";
import { FileBrowserNapeosContext, FileBrowserNapeosFileManager, ProgramsContext, ProgramviewContext, withContext, } from "@focus/focusUI";
export const simplifyPath = (path) => {
    const parts = path.split("/").slice(1);
    const new_path = [];
    let length = 0;
    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part === ".." || part === "") {
            if (part === ".." && (length === 0 || new_path[length - 1] === "..")) {
                new_path[length++] = part;
            }
            else if (part === ".." && length > 0) {
                length--;
            }
            continue;
        }
        new_path[length++] = part;
    }
    if (length === 0) {
        return "/";
    }
    let result = "";
    for (let i = 0; i < length; i++) {
        result += `/${new_path[i]}`;
    }
    return result;
};
export class _FileBrowserNapeosContainer extends React.Component {
    constructor(props) {
        super(props);
        this.navigateDirectory = (name) => {
            const simpPath = simplifyPath(name);
            this.props.fetchFiles({
                relLocation: simpPath,
                program: this.props.program,
                scenario: this.props.scenario,
                workspace: this.props.workspace,
                mode: this.props.mode,
            });
            this.setState({
                currentPath: simpPath,
            });
        };
        this.state = {
            currentPath: this.props.currentPath,
            loaded: false,
        };
    }
    componentDidUpdate() {
        if (this.props.isDialogOpen && !this.state.loaded) {
            let currentPath = typeof this.state.currentPath !== "undefined" &&
                this.state.currentPath !== ""
                ? this.state.currentPath
                : "";
            this.props.fetchFiles({
                relLocation: currentPath,
                program: this.props.program,
                scenario: this.props.scenario,
                workspace: this.props.workspace,
                mode: this.props.mode,
            });
            this.setState({ loaded: true });
        }
    }
    render() {
        return (React.createElement(FileBrowserNapeosFileManager, { isDialogOpen: this.props.isDialogOpen, currentPath: this.state.currentPath, navigateDirectory: this.navigateDirectory, onAccept: this.props.onAccept, onCancel: this.props.onCancel }));
    }
}
const mapDispatchToProps = (dispatch, { __filebrowsernapeos }) => {
    return {
        fetchFiles: (payload) => dispatch(__filebrowsernapeos.actions.fetchItem(payload)),
    };
};
const mapStateToProps = (state, { __programs, __programview }) => {
    return {
        scenario: getSelectedScenarioName(state.scenarios),
        workspace: getSelectedWorkspaceName(state.scenarios),
        program: __programs.selectors.getSelectedProgram(state.programs),
        mode: __programview.selectors.getMode(state.programview),
    };
};
const Connected = connect(mapStateToProps, mapDispatchToProps)(_FileBrowserNapeosContainer);
const contextConfig = {
    __filebrowsernapeos: FileBrowserNapeosContext,
    __programs: ProgramsContext,
    __programview: ProgramviewContext,
};
export const FileBrowserNapeosContainer = withContext(contextConfig)(Connected);
//# sourceMappingURL=FileBrowserNapeosContainer.js.map